$(document).ready(function () {
  // ACCORDION SECTIONS
  function closeAccordionSection() {
    $(".accordion .accordion-section-title").removeClass("active");
    $(".accordion .accordion-section-content").slideUp(300).removeClass("open");
  }

  $(".accordion-section-title").on("click", function (e) {
    const currentAttrValue = $(this).attr("href");
    if ($(this).hasClass("active")) {
      closeAccordionSection();
    } else {
      closeAccordionSection();
      $(this).addClass("active");
      $(".accordion " + currentAttrValue)
        .slideDown(300)
        .addClass("open");
    }
    e.preventDefault();
  });

  // The old, conflicting Fitment Widget and Add to Cart code has been removed.
});
// Add this to your <script> tag in theme.liquid or custom.js
document.addEventListener("DOMContentLoaded", () => {
  const vinForm = document.querySelector("#vin-form"); // Adjust selector to your VIN input form
  if (vinForm) {
    vinForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const vinInput = vinForm.querySelector('input[name="vin"]');
      const vin = vinInput.value;

      const response = await fetch("/submit-vin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vin }),
        credentials: "include", // For CORS with cookies
      });

      const result = await response.json();
      if (result.success) {
        // Create and show popup
        const popup = document.createElement("div");
        popup.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          padding: 20px;
          border: 1px solid #ccc;
          box-shadow: 0 0 10px rgba(0,0,0,0.5);
          z-index: 1000;
          max-height: 80vh;
          overflow-y: auto;
        `;
        popup.innerHTML = `
          <h2>VIN Decoder Results</h2>
          <p><strong>VIN:</strong> ${result.popup_data.vin}</p>
          <p><strong>Vehicle:</strong> ${result.popup_data.vehicle}</p>
          ${Object.entries(result.popup_data.attributes)
            .map(
              ([key, value]) => `
            <p><strong>${key}:</strong> ${value}</p>
          `
            )
            .join("")}
          <button onclick="this.parentElement.remove()">Close</button>
        `;
        document.body.appendChild(popup);
      } else if (result.error) {
        alert(result.error); // Or display error differently
      }
    });
  }
});
